import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

function CreateUser({ isCreating, registerUser }) {
  const initialValues = {
    name: '',
    email: '',
    mobile: '',
    password: '',
    retypePassword: '',
  };

  const ValidationSchema = Yup.object({
    name: Yup.string().trim().required('Required'),
    email: Yup.string().trim().email('Invalid email').required('Required'),
    mobile: Yup.string()
      .trim()
      .required('Required')
      .matches(/^[0-9]{7,15}$/, 'Enter a valid phone number'),
    password: Yup.string().required('Required'),
    retypePassword: Yup.string()
      .required('Required')
      .oneOf([Yup.ref('password'), null], 'Passwords must match'),
  });

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const query = {
        name: values.name,
        email: values.email,
        mobile: values.mobile,
        password: values.password,
        password1: values.retypePassword,
      };
      await registerUser(query);
    } catch (error) {
      console.error('Registration error:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="row">
      <div>&nbsp;</div>
      <section className="well create-piece">
        <Formik
          initialValues={initialValues}
          validationSchema={ValidationSchema}
          onSubmit={onSubmit}
          validateOnBlur
          validateOnChange
        >
          {({ touched, values, isSubmitting }) => {
            const showMatch = touched.retypePassword || touched.password;
            const matched =
              values.password.length > 0 &&
              values.retypePassword.length > 0 &&
              values.password === values.retypePassword;

            return (
              <Form>
                <div className="row">
                  <div className="col-md-3">
                    <label>Name</label>
                  </div>
                  <div className="col-md-9">
                    <div className="form-group">
                      <Field
                        name="name"
                        placeholder="Name"
                        type="text"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger small mt-1"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <label>Email</label>
                  </div>
                  <div className="col-md-9">
                    <div className="form-group">
                      <Field
                        name="email"
                        placeholder="Email"
                        type="email"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger small mt-1"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <label>Mobile</label>
                  </div>
                  <div className="col-md-9">
                    <div className="form-group">
                      <Field
                        name="mobile"
                        placeholder="Mobile"
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="mobile"
                        component="div"
                        className="text-danger small mt-1"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <label>Password</label>
                  </div>
                  <div className="col-md-9">
                    <div className="form-group">
                      <Field
                        name="password"
                        placeholder="Password"
                        type="password"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-danger small mt-1"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <label>Retype Password</label>
                  </div>
                  <div className="col-md-9">
                    <div className="form-group">
                      <Field
                        name="retypePassword"
                        placeholder="Retype Password"
                        type="password"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="retypePassword"
                        component="div"
                        className="text-danger small mt-1"
                      />

                      {showMatch && (
                        matched ? (
                          <div className="match-valid">Entered passwords matched</div>
                        ) : (
                          <div className="match-invalid">Entered passwords do not match</div>
                        )
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="create-piece__btn-container">
                    <button
                      className="cus-btn-primary btn-block btn-lg"
                      type="submit"
                      disabled={isCreating || isSubmitting}
                    >
                      {(isCreating || isSubmitting) ? (
                        <span className="spinner" />
                      ) : (
                        <span>Create</span>
                      )}
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </section>
    </div>
  );
}

export default CreateUser;
